import request from '../request'

// 训练营邀请信息
export function market_camp_invite_info(params) {
    return request({
      url: '/market/camp/common/invite/info',
      method: 'get',
      params,
    })
  }